import { render } from "./salon-card.vue?vue&type=template&id=f56c25aa&scoped=true&ts=true"
import script from "./salon-card.vue?vue&type=script&lang=ts"
export * from "./salon-card.vue?vue&type=script&lang=ts"

import "./salon-card.vue?vue&type=style&index=0&id=f56c25aa&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56c25aa"]])

export default __exports__